import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import reportWebVitals from "./reportWebVitals";
import { setUpStore } from "./redux/store";

import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, createTheme } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { SideBarItemsProvider } from "./context/sidebarContext";
import { DeviceSocketProvider, SocketProvider } from "./context/socketContext";
import { TourProvider } from "./context/tourContext";
import { PlantProvider } from "./context/plantContext";

const appFont = createTheme({
	typography: {
		fontFamily: ["Nunito", "serif"].join(","),
	},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<React.StrictMode>
	<Provider store={setUpStore()}>
		<BrowserRouter>
			<ThemeProvider theme={appFont}>
				<PlantProvider>
					<TourProvider>
						<SocketProvider>
							<DeviceSocketProvider>
								<AppRoutes />
								<ToastContainer position="bottom-center" limit={1}/>
							</DeviceSocketProvider>
						</SocketProvider>
					</TourProvider>
				</PlantProvider>
			</ThemeProvider>
		</BrowserRouter>
	</Provider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
